import {
    AfterViewInit, Component, HostListener, Sanitizer, SecurityContext, ViewChild,
    ViewEncapsulation
} from "@angular/core";
import {StateService} from "../../service/state";
import {ApiService} from "../../service/api";
import {ActivatedRoute} from "@angular/router";
import {CartService} from "../../service/cart";
import {DomSanitizer, Meta} from "@angular/platform-browser";
import {CartNotificationComponent} from "../../components/cart-notification/cart-notification.component";
import {FormBuilder, FormGroup, Validators} from "@angular/forms";
import {MatDialog} from "@angular/material";
import {SwiperComponent, SwiperConfig} from "ngx-swiper-wrapper";

@Component({
    selector: 'fw-article-detail',
    templateUrl: './detail.html',
    encapsulation: ViewEncapsulation.None,
    styleUrls: [
        './detail.scss'
    ]
})
export class HomeArticleDetail implements AfterViewInit {
    public galleryIndex = 0;
    public article: any = false;
    public images: any[] = [];
    public metadata: string[];

    public galleryTop: any;
    public galleryThumb: any;

    public topGalleryConfig: any = {};

    public bottomGalleryConfig: any = {};
    public cartForm: FormGroup;

    @ViewChild('gallery') swiper: SwiperComponent;

    constructor(public stateService: StateService,
                public apiService: ApiService,
                public route: ActivatedRoute,
                public sanitizer: Sanitizer,
                public domsanitizer: DomSanitizer,
                public cart: CartService,
                public dialog: MatDialog,
                public fb: FormBuilder,
                public meta: Meta) {

        this.cartForm = fb.group({
            color: ['', Validators.required],
            amount: ['1', [Validators.pattern('^\\d*[1-9]\\d*$'), Validators.required]]
        });

        const data = this.route.snapshot.data['article'];
        data.article.sourcecode_safe = sanitizer.sanitize(SecurityContext.HTML, this.externalLink(data.article.sourcecode));
        this.article = data.article;
        this.images = data.images;

        this.topGalleryConfig = {
            lazy: true,
            updateOnImagesReady: true
        };

        this.bottomGalleryConfig = {
            spaceBetween: 10,
            centeredSlides: true,
            slidesPerView: 'auto',
            touchRatio: 0.2,
            slideToClickedSlide: true
        }
    }

    isIpad() {
        return /ipad/i.test(navigator.userAgent.toLowerCase());
    }

    ngAfterViewInit() {
        setTimeout(() => {
            window.dispatchEvent(new Event('resize'));
        }, 150);
    }

    changeIndex(index) {
        this.galleryIndex = index;
    }

    externalLink(code: string): string {
        let pattern = /(\b(https?):\/\/[^"]*)/gim;
        code = code.replace(pattern, '$1" target="_blank');

        return code;
    }

    safeURL(path) {
        return this.sanitizer.sanitize(SecurityContext.URL, path);
    }

    safeStyle(path) {
        return this.domsanitizer.bypassSecurityTrustStyle('url(' + path + ')');
    }

    addToCart(article) {
        if (!this.cartForm.valid && parseInt(this.cartForm.get('amount').value) > 0) {
            return;
        }

        this.cart.addItem(article, parseInt(this.cartForm.get('amount').value), this.cartForm.get('color').value);
        this.cartForm.reset({
            color: '',
            amount: '1'
        });
        let dialogRef = this.dialog.open(CartNotificationComponent, {});
        setTimeout(() => {
            dialogRef.close();
        }, 1000)
    }
}



// WEBPACK FOOTER //
// ./src/app/pages/article/detail.ts